'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messages: { type: Object, default: null },
        msgType: { type: String, default: '' }
    },
    data: function data() {
        return {
            showMsg: false,
            timeout: null
        };
    },
    events: {
        'showmsg': function showmsg(data) {
            if (data.messages) {
                this.messages = data.messages;
            }

            if (data.type) {
                this.msgType = data.type;
            }
        }
    },
    watch: {
        'messages': function messages(val) {
            if (val) {

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                var self = this;
                this.showMsg = true;
                this.timeout = setTimeout(function () {
                    self.showMsg = false;
                    setTimeout(function () {
                        if (!self.showMsg) {
                            self.messages = null;
                            self.msgType = '';
                        }
                    }, 500);
                }, 3000);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=msg-bar v-bind:class=\"{\n'msg-bar--hide': !showMsg,\n'msg-bar--show': showMsg,\n'msg-bar--success': msgType == 'success',\n'msg-bar--negative': msgType == 'error',\n'msg-bar--info': msgType == 'info',\n'msg-bar--warning': msgType == 'warning'\n}\"><p v-for=\"(key, error) in messages\">{{ error }}</div>"
